import toast from 'react-hot-toast';
import { isSessionExpiredPopupOpen } from 'common/sessionState';

const TOAST_METHODS = ['success', 'error', 'loading', 'custom', 'promise', 'message'];

export function setupToastGuard() {
  TOAST_METHODS.forEach((method) => {
    const original = toast[method]?.bind(toast);
    if (!original) return;

    toast[method] = (...args) => {
      if (isSessionExpiredPopupOpen()) return;
      return original(...args);
    };
  });
}
